import { c as _c } from "react/compiler-runtime";
import React, { PropsWithChildren, ReactNode } from 'react';
import { mergeClasses } from '@/utils/style';
type TextProps = PropsWithChildren<{
  as?: 'div' | 'p' | 'span' | 'li';
  variant?: 'p1' | 'p2' | 'p3' | 'p4';
  weight?: 'regular' | 'semibold';
  className?: string;
}>;
const sizes = {
  p1: 'text-base md:text-[1.375rem] leading-[160%]! md:leading-[170%]!',
  p2: 'text-base md:text-lg leading-[160%]!',
  p3: 'text-sm md:text-base leading-[165%]! md:leading-[160%]! tracking-[.01em] md:tracking-normal',
  p4: 'text-xs md:text-sm leading-[160%]!'
};
const weights = {
  regular: 'font-normal',
  semibold: 'font-semibold'
};
export const Text = t0 => {
  const $ = _c(8);
  const {
    as: t1,
    variant: t2,
    weight: t3,
    className,
    children
  } = t0;
  const as = t1 === undefined ? "p" : t1;
  const variant = t2 === undefined ? "p2" : t2;
  const weight = t3 === undefined ? "regular" : t3;
  const sizeClasses = sizes[variant];
  const weightClass = weights[weight];
  const TextTag = as;
  let t4;
  if ($[0] !== className || $[1] !== sizeClasses || $[2] !== weightClass) {
    t4 = mergeClasses(sizeClasses, weightClass, className);
    $[0] = className;
    $[1] = sizeClasses;
    $[2] = weightClass;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== TextTag || $[5] !== children || $[6] !== t4) {
    t5 = <TextTag className={t4}>{children}</TextTag>;
    $[4] = TextTag;
    $[5] = children;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export default Text;